import type { RfxListTab } from "../../types/rfx-list.type";

/**
 * `panel` only offers these two tabs (`App\Enums\RfxListScope::tabs()` —
 * pinned in rfx-tab-config.test.ts / task-007.review.md). A drift here is a
 * silent-empty-tab bug — fail loud instead.
 */
export const PANEL_TABS: readonly RfxListTab[] = ["current", "past"] as const;

export const assertKnownPanelTab = (tab: RfxListTab): void => {
	if (!(PANEL_TABS as readonly string[]).includes(tab)) {
		throw new Error(`Unrecognised panel tab key "${tab}" — FE/BE tab-map drift.`);
	}
};

export const getPanelEmptyStateCopy = (tab: RfxListTab): string => {
	switch (tab) {
		case "current":
			return "No current RFx to evaluate.";
		case "past":
			return "No past panel activity.";
		default:
			throw new Error(`Unrecognised panel tab key "${tab}" — FE/BE tab-map drift.`);
	}
};
